export const YOUTUBE_LICENSE_MAP = {
  youtube: 'Standard YouTube License',
  creativeCommon: 'Creative Commons - Attribution',
}
